// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import {application} from "./application"

import HelloController from "./hello_controller"
import MassTargetsController from "./mass_targets_controller"
import FellowToAcceptController from "./fellow_to_accept_controller"
import CheckBoxCollapseController from "./check_box_collapse_controller"

application.register("hello", HelloController)

application.register("massTargets", MassTargetsController)
application.register("fellowToAccept", FellowToAcceptController)
application.register("checkBoxCollapse", CheckBoxCollapseController)
